import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js';
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js';
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title> Myringoplasty Surgery | Eardrum Repair & Surgery Cost in Delhi, India </title>
            <meta name="description" content="Get expert myringoplasty surgery in Delhi, India, at an affordable cost. Advanced eardrum repair and hole surgery by skilled ENT specialists for better hearing." />
            <meta name="keywords" content="Myringoplasty Surgery, Myringoplasty Surgery Cost, Eardrum Surgery Cost in Delhi, Eardrum Hole Surgery Cost in Delhi, Eardrum Repair Surgery Cost in India,  Myringoplasty Treatment" />
            <link rel="canonical" href="https://entdelhi.com/myringoplasty/" />
            <meta property="og:title" content="Myringoplasty Surgery | Eardrum Repair & Surgery Cost in Delhi, India" />
            <meta property="og:description" content="Get expert myringoplasty surgery in Delhi, India, at an affordable cost. Advanced eardrum repair and hole surgery by skilled ENT specialists for better hearing." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />   
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
